import React from 'react';
import useTranslation from '../../hooks/useTranslation';
import useSelectedDeck from '../../hooks/useSelectedDeck';
import QuizLearnPage from './QuizLearnPage';
import CardLearnPage from './CardLearnPage';
import WordLearnPage from "./WordLearnPage";

const LearnPage = () => {
    const { t } = useTranslation();
    const selectedDeck = useSelectedDeck();
    // selectedDeck инициализируется null (deckReducer), undefined не бывает —
    // отдельной ветки со спиннером не нужно
    if (!selectedDeck) {
        return (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <p>{t('deck.selectToStartLearning')}</p>
            </div>
        );
    }

    const selectedType = selectedDeck.type;

    const renderContentForm = () => {
        switch (selectedType) {
            case 'QUIZ':
                return <QuizLearnPage />;
            case 'CARD':
                return <CardLearnPage />;
            case 'WORD':
                return <WordLearnPage />;
            default:
                return <div>{t('deck.selectValidType')}</div>;
        }
    };

    return (
        <div style={{ width: '100%', paddingTop: '20px' }}>
            <div style={{ marginTop: '10px', width: '100%' }}>
                {renderContentForm()}
            </div>
        </div>
    );
};

export default LearnPage;
